import React, { useEffect, useMemo, useState } from "react";
import moreBtnTableIcon from "../../img/moreButtonTable.svg";
import addPlusIcon from "../../img/addPlusIcon.svg";
import rowBackIcon from "../../img/rowBackMiniIcon.svg";
import CreateNewDocuments from "../ReusedComponents/CreateNewDocuments/CreateNewDocuments";
import Search from "../Search/Search";
import { onHandleShowTableMenu } from "../../utils/OnHandleShowTableMenu/OnHandleShowTableMenu";
import TableRowMenu from "../ReusedComponents/TableRowMenu/TableRowMenu";
import CreateDocSetBolModal from "../CreateDocSetBolModal/CreateDocSetBolModal";
import SelectedDocSetBol from "../SelectedDocSetBol/SelectedDocSetBol";
import { findStatusDocument } from "../../utils/FindStatusDocument/FindStatusDocument";
import useAxiosPrivate from "../../utils/CustomHooks/useAxiosPrivate/useAxiosPrivate";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import { axiosPutUpdateBol } from "../../Api/ApiBol/axiosPutUpdateBol";
import { axiosPostAddNewBol } from "../../Api/ApiBol/axiosPostAddNewBol";
import useOnShowEditAddDocsButton from "../../utils/CustomHooks/useOnShowEditAddDocsButton/useOnShowEditAddDocsButton";
import selectedDocSetBol from "../SelectedDocSetBol/SelectedDocSetBol";

const CargoCaseDocSetBol = (props) => {
  const { 
      activeNoLoadingOrder, 
      cargoCaseDocument, 
      isNewDocCargoCase } = props;

  const [filter, setFilter] = useState("");

  const axiosPrivate = useAxiosPrivate();
  const cargoCaseDocId = cargoCaseDocument[0].id;
  const { auth, getRequestDataToggle, getIdCreateDoc, stateReducer, cleanIdSelectDoc } = useAuth();
  const [editDoc, setEditDoc] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isShowRowBack, setShowRowBack] = useState(false);
  const [activeTableRowMenu, setActiveTableRowMenu] = useState(null);
  const [selectedCargoCaseBol, setSelectedCargoCaseBol] = useState([]);
  const [activeDocSetBolTable, setActiveDocSetBolTable] = useState(true);
  const [activeCreateBolModal, setActiveCreateBolModal] = useState(false);
  const [activeDocSetBolNotFound, setActiveDocSetBolNotFound] = useState(false);
  const [isShowAddBtn, setShowAddBtn] = useOnShowEditAddDocsButton(
    auth,
    cargoCaseDocument
  );
  const cargoCaseBol = useMemo(
    () => cargoCaseDocument.map((el) => el?.bols),
    [cargoCaseDocument]
  );

  useEffect(() => {
    let isMounted = true;

    if (isNewDocCargoCase === true || cargoCaseBol[0]?.length === 0) {
      isMounted && setActiveDocSetBolTable(false);
      isMounted && setActiveDocSetBolNotFound(true);
    } else {
      isMounted && setActiveDocSetBolTable(true);
      isMounted && setActiveDocSetBolNotFound(false);
    }

    return () => {
      isMounted = false;
    };
  }, [isNewDocCargoCase, cargoCaseBol]);

  function onShowCurrentDoc(id) {
    const currentCargoCaseBol = cargoCaseBol[0]?.find((el) => el?.id === id);
    setActiveDocSetBolTable(false);
    setSelectedCargoCaseBol([currentCargoCaseBol]);
    setShowRowBack(true);
  }

  function onShowCreateBolModal(activeNoLoadingOrder, cargoCaseDocId, cargoCaseDocument) {
    if (cargoCaseDocument[0]?.captain === undefined || cargoCaseDocument[0]?.shipowner === undefined || cargoCaseDocument[0]?.vesselFlag === undefined) {
      if (cargoCaseDocId === undefined) {
        setErrorMessage("First you need to create loading order a cargo case!");
        setActiveCreateBolModal(false);
      } else {
        setErrorMessage("The captain or shipowner or flag for vessel has not been added to the order!");
        setActiveCreateBolModal(false);
      }
    } else {
      switch (activeNoLoadingOrder) {
        case false :
          setActiveCreateBolModal(true);
          setErrorMessage("");
          break;
        case cargoCaseDocId !== undefined :
          setActiveCreateBolModal(true);
          setErrorMessage("");
          break;
        default:
          setErrorMessage("First you need to create loading order a cargo case!");
          setActiveCreateBolModal(false);
      }
    }
  }

  function onHandleAddBol(cargoCaseDocument) {
    if (cargoCaseDocument[0]?.captain === undefined || cargoCaseDocument[0]?.shipowner === undefined || cargoCaseDocument[0]?.vesselFlag === undefined) {
      setErrorMessage("The captain or shipowner or flag for vessel has not been added to the order!");
    } else {
      setActiveCreateBolModal(true);
    }
  }

  function onEditActiveMode() {
    if (editDoc === false) {
      setActiveCreateBolModal(true);
      setEditDoc(true);
    }
  }

  function addBolCargoCase(body, currentId) {
    if (editDoc === true && currentId !== undefined) {
      axiosPutUpdateBol(
        axiosPrivate,
        currentId,
        body,
        getRequestDataToggle,
        getIdCreateDoc,
        setEditDoc,
        setActiveCreateBolModal,
        setErrorMessage
      );
    } else {
      axiosPostAddNewBol(
        axiosPrivate,
        body,
        getRequestDataToggle,
        getIdCreateDoc,
        setActiveCreateBolModal,
        setErrorMessage
      );
    }
  }

  useEffect(() => {
    let isLoading = true;

    if (selectedCargoCaseBol[0]?.id !== undefined) {
      const currentCargoCaseBol = cargoCaseBol[0]?.find(
        (el) => el?.id === selectedCargoCaseBol[0]?.id
      );
      isLoading && setActiveDocSetBolTable(false);
      isLoading && setSelectedCargoCaseBol([currentCargoCaseBol]);
    }
    return () => {
      isLoading = false;
    };
  }, [cargoCaseDocument]);

  function closeModal() {
    setActiveCreateBolModal(false);
    setEditDoc(false);
  }

  const handleBackToTable = () => {
    setActiveDocSetBolTable(true);
    setSelectedCargoCaseBol([]);
    setShowRowBack(false);
  };

  useEffect(() => {
    let isMounted = true;
    if (stateReducer.idSelectDoc.typeDoc === 'BOL' && stateReducer.idSelectDoc.idDoc !== undefined) {
      isMounted && onShowCurrentDoc(stateReducer.idSelectDoc.idDoc)
      isMounted && cleanIdSelectDoc(stateReducer.idSelectDoc.idDoc)
    }
    return () => {
      isMounted = false;
    }

  },[stateReducer.idSelectDoc])

  return (
    <div className="cargo-case-doc-set-bol__container">
      <div className="cargo-case-doc-set-bol__title">
        <div className="cargo-case-doc-set-bol__title-row">
          {isShowRowBack ? (
            <div
              onClick={() => handleBackToTable()}
              className="cargo-case-doc-set-man__title-row-back"
            >
              <img
                className="cargo-case-doc-set-bol__title-icon"
                src={rowBackIcon}
                alt={"icon row"}
              />
              <p className="cargo-case-doc-set-bol__title-name">
                Back to table
              </p>
            </div>
          ) : (
            <h4 className="cargo-case-doc-set-bol__title-name">BOL</h4>
          )}
        </div>
      </div>
      {activeDocSetBolNotFound ? (
        <div className="cargo-case-doc-set-bol__document-not-found">
          <CreateNewDocuments
            handeClickCreateNew={() =>
              onShowCreateBolModal(activeNoLoadingOrder, cargoCaseDocId, cargoCaseDocument)
            }
            hiddenUploadBtn={true}
            cargoCaseDocument={cargoCaseDocument}
            isNewDocCargoCase={isNewDocCargoCase}
          />
          <p className="cargo-case-doc-set-bol__document-not-found-error-message">
            {errorMessage}
          </p>
        </div>
      ) : (
        <div className="cargo-case-doc-set-bol__table">
          {activeDocSetBolTable ? (
            <div className="cargo-case-doc-set-bol__table-block">
              <div className="cargo-case-doc-set-bol__table-block-search-add-new">
                <div className="cargo-case-doc-set-bol__search">
                  <Search value={filter} setValue={setFilter} />
                </div>
                {isShowAddBtn && (
                    <div className="cargo-case-doc-set-bol__add-new-btn-container">
                      <div
                          onClick={() => onHandleAddBol(cargoCaseDocument)}
                          className="cargo-case-doc-set-bol__add-new-btn"
                      >
                        <img
                            className="cargo-case-doc-set-bol__add-new-btn-icon"
                            src={addPlusIcon}
                            alt={"иконка плюс"}
                        />
                        <p className="cargo-case-doc-set-bol__name-btn">Add BOL</p>
                      </div>
                      <p className="cargo-case-doc-set-bol__add-new-btn__document-not-found-error-message">
                        {errorMessage}
                      </p>
                    </div>
                )}
              </div>
              <div className="cargo-case-doc-set-bol__table-header">
                <p>B/L No.</p>
                <p>Data</p>
                <p>Gross quantity (kilos)</p>
                <p>Description of goods</p>
                <p>Net quantity</p>
                <p>BBLS gross</p>
                <p>BBLS net</p>
                <p>Status</p>
              </div>
              {cargoCaseBol[0]
                .filter((el) => el?.bookingRef.includes(filter))
                .map((el) => {
                  return (
                    <div
                      onClick={() => onShowCurrentDoc(el?.id)}
                      key={el?.id}
                      className="cargo-case-doc-set-bol__table-row"
                    >
                      <p>{el?.bookingRef}</p>
                      <p>{el?.dateOfLoading}</p>
                      <p>{el?.grossQuantity}</p>
                      <p>{el?.descriptionOfGoods}</p>
                      <p>{el?.netQuantity}</p>
                      <p>{el?.bblsGross}</p>
                      <p>{el?.bblsNet}</p>
                      <div className="cargo-case-table-row-status">
                        <img
                          className="cargo-case-table-row-status__icon-prepared"
                          src={findStatusDocument(el?.status)}
                          alt={"иконка подготовлен"}
                        />
                        {/* <img onClick={(e) => onHandleShowTableMenu(el?.id, activeTableRowMenu, setActiveTableRowMenu, e)}  className="cargo-case-table-row-status__icon-more-btn" src={moreBtnTableIcon} alt={'иконка показать больше'}/>
                                            <TableRowMenu
                                                index={el?.id}
                                                activeTableRowMenu={activeTableRowMenu}
                                            /> */}
                      </div>
                    </div>
                  );
                })}
            </div>
          ) : (
            <>
              <SelectedDocSetBol
                selectedCargoCaseBol={selectedCargoCaseBol}
                onEditHandler={() => onEditActiveMode()}
                cargoCaseDocId={cargoCaseDocId}
              />
            </>
          )}
        </div>
      )}
      {activeCreateBolModal && (
        <CreateDocSetBolModal
          closeModal={closeModal}
          activeNoLoadingOrder={activeNoLoadingOrder}
          cargoCaseDocument={cargoCaseDocument}
          addBolCargoCase={addBolCargoCase}
          errorMessage={errorMessage}
          editDoc={editDoc}
          selectedCargoCaseBol={selectedCargoCaseBol}
        />
      )}
    </div>
  );
};
export default CargoCaseDocSetBol;
